module.exports = __webpack_public_path__ + "img/l2.1916b2e7.png";